import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
import 'photoswipe/style.css';
import { isWebpSupported } from "../utils";
export function initPhotoPopups() {
    const defaults = {
        children: 'a',
        pswpModule: PhotoSwipe,
        bgClickAction: 'close',
        bgOpacity: 1,
        closeTitle: 'Закрыть',
        zoomTitle: 'Увеличить',
        initialZoomLevel: ({ panAreaSize, itemData }) => {
            if (panAreaSize.y > panAreaSize.x) {
                const maxSize = Math.min(panAreaSize.x, panAreaSize.y - 120);
                const imageMaxSize = Math.max(itemData.width, itemData.height);
                return Math.min(maxSize / imageMaxSize, 1);
            }
            return Math.min(panAreaSize.x / itemData.width, (panAreaSize.y - 120) / itemData.height, 1);
        },
        arrowPrevTitle: 'Предыдущая фотография',
        arrowNextTitle: 'Следующая фотография',
        errorMsg: 'Не удалось загрузить фотографию',
    };
    const productGallery = new PhotoSwipeLightbox({
        ...defaults,
        gallery: '#prod-item-swiper',
    });
    let initialSlide;
    productGallery.addFilter('clickedIndex', index => initialSlide = index);
    productGallery.addFilter('itemData', parseWebpSource);
    productGallery.addFilter('itemData', (data, index) => ({ ...data, autoplay: initialSlide === index }));
    productGallery.addFilter('thumbBounds', calculateThumbBounds);
    // support youtube content
    productGallery.on('contentLoad', (e) => {
        const { content } = e;
        if (content.type === 'youtube') {
            e.preventDefault();
            content.element = document.createElement('div');
            content.element.className = 'pswp__youtube-container';
            const iframe = document.createElement('iframe');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay');
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.src = content.data.src.replace(/\/watch\?v=/, '/embed/') + '?enablejsapi=1' + (content.data.autoplay ? '&autoplay=1' : '');
            content.element.appendChild(iframe);
        }
    });
    productGallery.on('change', () => {
        document.getElementById('prod-item-swiper').swiper.slideTo(productGallery.pswp.currIndex);
    });
    productGallery.on('contentDeactivate', ({ content }) => {
        if (content.data.type === 'youtube') {
            content.element.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
    });
    productGallery.init();
    const reviewGallery = new PhotoSwipeLightbox({
        ...defaults,
        gallery: '.review-item__photos',
    });
    reviewGallery.addFilter('thumbBounds', calculateThumbBounds);
    reviewGallery.addFilter('itemData', parseWebpSource);
    reviewGallery.init();
}
function calculateThumbBounds(_thumbBounds, itemData) {
    const imageAspectRatio = itemData.width / itemData.height;
    const boxWidth = itemData.element.clientWidth;
    const boxHeight = itemData.element.clientHeight;
    const boxAspectRatio = itemData.element.clientWidth / itemData.element.clientHeight;
    const boxRect = itemData.element.getBoundingClientRect();
    if (boxAspectRatio > imageAspectRatio) {
        const width = boxWidth * (imageAspectRatio / boxAspectRatio);
        return {
            w: width,
            x: boxRect.x + (boxWidth - width) / 2,
            y: boxRect.y,
        };
    }
    return {
        w: boxWidth,
        x: boxRect.x,
        y: boxRect.y + (boxHeight - boxHeight * (boxAspectRatio / imageAspectRatio)) / 2,
    };
}
function parseWebpSource(itemData) {
    if (isWebpSupported()) {
        itemData.src = itemData.src.replace(/(\.bmp)?\.(jpe?g|png|gif)$/i, '\.webp');
    }
    return itemData;
}
